export function getIntercomScriptUrl(appId: string | undefined) {
    // Guard against a missing OR blank app id: an empty/whitespace value (e.g. when the
    // REACT_APP_INTERCOM_APPID build secret is unset) would otherwise build the bogus URL
    // "https://widget.intercom.io/widget/", which loads a script and lets the status reach
    // LoggedIn, yet show() never opens because there is no real Intercom workspace.
    if (!appId || appId.trim() === "") return ""
    return `https://widget.intercom.io/widget/${appId}`
}

export function initGlobals() {
    const w = window
    const ic = w.Intercom
    if (typeof ic === "function") {
        ic("reattach_activator")
        ic("update", w.intercomSettings)
    } else {
        const i = function (...args: any[]) {
            i.c(...args)
        }
        i.q = [] as any[]
        i.c = function(...args: any[]) {
            i.q.push(args)
        }
        w.Intercom = i
    }
}
